import { useState } from "react";
import { api } from "@/App";
import { Loader2, Monitor, Trash2 } from "lucide-react";

const errText = (x) => (typeof x.response?.data?.detail === "string" ? x.response.data.detail : "Something went wrong, please try again.");

export const ManageMachines = () => {
  const [key, setKey] = useState("");
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(null);
  const call = async (path, extra, tag) => {
    setBusy(tag); setErr(null);
    try { const { data } = await api.post(path, { key: key.trim().toUpperCase(), ...extra }); setInfo(data); } catch (x) { setErr(errText(x)); }
    setBusy(null);
  };
  const remove = (m) => { if (window.confirm(`Remove machine ${m}? This frees a slot so you can activate another computer.`)) call("/denoise/machines/remove", { machine_id: m }, m); };
  return (
    <section id="machines" className="scroll-mt-6 max-w-xl mx-auto mt-6 space-y-4 border border-[#2a2f3d] bg-[#0e1013] p-8" data-testid="manage-machines">
      <h2 className="font-display uppercase text-2xl flex gap-2 items-center"><Monitor size={20} className="text-[#00e5ff]" /> Changed computer?</h2>
      <p className="text-sm text-[#9ba3b4]">See where your Denoise, Skin, Texture or Reactor key is activated and free up a slot for your new computer (up to 3 removals per 12 months).</p>
      <form onSubmit={(e) => { e.preventDefault(); call("/denoise/machines", {}, "list"); }} className="flex gap-2">
        <input value={key} onChange={(e) => setKey(e.target.value)} placeholder="KKD-…, KKS-…, KKT-… or KKF-…" className="flex-1 bg-black border border-[#2a2f3d] px-3 py-2 font-mono text-sm uppercase outline-none focus:border-[#00e5ff]" data-testid="manage-key-input" />
        <button disabled={!!busy || !key.trim()} className="btn-ghost px-4 py-2 text-xs flex items-center gap-2" data-testid="manage-show-btn">{busy === "list" && <Loader2 className="spin" size={12} />} Show machines</button>
      </form>
      {err && <p className="text-xs text-[#ff453a]" data-testid="manage-error">{err}</p>}
      {info && (
        <div className="space-y-2" data-testid="manage-list">
          <p className="text-xs font-mono text-[#9ba3b4]" data-testid="manage-summary">{info.machines.length} of {info.machines_max} machines · {info.removals_left} removals left this year</p>
          {info.machines.length === 0 && <p className="text-sm text-[#5c6479]">No machines activated yet.</p>}
          {info.machines.map((m) => (
            <div key={m} className="flex items-center gap-3 border border-[#2a2f3d] px-3 py-2" data-testid={`manage-machine-${m}`}>
              <span className="font-mono text-sm flex-1">{m}</span>
              <button onClick={() => remove(m)} disabled={!!busy || info.removals_left < 1} className="btn-ghost px-3 py-1 text-xs flex items-center gap-1" data-testid={`manage-remove-${m}`}>
                {busy === m ? <Loader2 className="spin" size={12} /> : <Trash2 size={12} />} remove
              </button>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};
